<template>
    <div class="accordion w-100" id="accordionExample">
      <slot></slot>            
    </div>
</template>

<script>
export default {
    name:"AccordionList"
}
</script>
